import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OmsServiceService } from '../../services/oms-service.service';
import { environment } from '../../../environments/environment';

@Component({
	selector: 'app-logout-confirm-modal',
	templateUrl: './logout-confirm-modal.component.html',
	styleUrls: ['./logout-confirm-modal.component.scss']
})

export class LogoutConfirmModalComponent implements OnInit {
  constructor(
    private modalService: NgbModal,
    public modal: NgbActiveModal,
    private omsService :OmsServiceService,
  ) { }

  ngOnInit(): void { }

  closePopup()
  {
    this.modal.close();
  }
  
  redictLoginPage()
  {
    this.logout();
  }

  logout() {  
    let clearSessionRequest = {};
    clearSessionRequest["session"] = window.localStorage.getItem('sessionId');
    clearSessionRequest["role"] = window.localStorage.getItem('role');
    this.omsService.clearUserSession(clearSessionRequest).subscribe(
      (res) => {
        window.localStorage.clear();
        // window.location.href="https://aiuat.callhealth.com/";
        window.location.href = environment.loginUrl;
      }
    )
  }
}